import React, { useState } from 'react'
import CountUp from 'react-countup';
import ScrollTrigger from 'react-scroll-trigger';
import { AiOutlinePlus } from "react-icons/ai";

export default function Counter1() {
    const [counteron,setcounteron]=useState(false);
  return (
    <ScrollTrigger onEnter={()=>setcounteron(true)} onExit={()=>setcounteron(false)}>
    <h1 style={{fontSize:"70px" ,fontFamily:"Trebuchet MS', sans-serif !important"}}>
    
    {counteron && <CountUp start={0}  end={399} duration={5} delay={0} /> } 
    <i style={{color:"red"}}> {<AiOutlinePlus/>} </i> 
    </h1>
    </ScrollTrigger>
  )
}
